import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const deleteAwardExecutiveSummaryFileTemplate: (
  fetchContext: FetchContext,
  awardId: number,
  accessToken?: string,
) => Promise<void> = (fetchContext, awardId, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/awards/${awardId}/executive-summary-file-template`,
  {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'delete award executive summary file template'));
